import { Box } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import TextFieldCompnent from "../../../components/textFieldComponent";
import MultipleSelectComponent from "../../../components/multipleSelectComponent";
import ButtonComponent from "../../../components/ButtonComponent";
import { useSelector } from "react-redux";
import { selectAllVariations } from "../../../features/variationSlice";
import { useTranslation } from "react-i18next";

const VariationForm = ({ buttonText, handleFormSubmit, initialValues, loading }) => {
    const { t } = useTranslation();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const variations = useSelector(selectAllVariations);
    
    const typeSchema = yup.object().shape({
        name: yup.string().required("Nom est requis"),
        label: yup.string().required("Libellé est requis"),
        message: yup.string(),
        variations: yup
            .array()
            .min(1, "Au moins une variation est requise")
            .required("Variation est requis"),
    });

    return (
        <Formik
            onSubmit={handleFormSubmit}
            initialValues={initialValues}
            validationSchema={typeSchema}
        >
            {({
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
            }) => (
                <form onSubmit={handleSubmit}>
                    <Box
                        display="grid"
                        gap="16px"
                        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 6" },
                        }}
                    >
                        <TextFieldCompnent
                            type="text"
                            label={t("fields.name")}
                            change={handleChange}
                            value={values.name}
                            name="name"
                            blur={handleBlur}
                            touched={touched.name}
                            error={errors.name}
                            colum="span 3"
                            row="1 / span 1"
                            required
                        />
                        <TextFieldCompnent
                            type="text"
                            label={t("fields.label")}
                            change={handleChange}
                            value={values.label}
                            name="label"
                            blur={handleBlur}
                            touched={touched.label}
                            error={errors.label}
                            colum="span 3"
                            row="2 / span 1"
                            required
                        />
                        <TextFieldCompnent
                            type="text"
                            label={t("fields.description")}
                            change={handleChange}
                            value={values.message}
                            name="message"
                            blur={handleBlur}
                            touched={touched.message}
                            error={errors.message}
                            colum="span 3"
                            row="3 / span 1"
                        />
                        <MultipleSelectComponent
                            label={t("fields.variations")}
                            name="variations"
                            gridColumn="span 3"
                            gridRow="4 / span 1"
                            required
                            items={variations || []}
                            value={values.variations}
                            change={(e) => {
                                handleChange({
                                    target: {
                                        name: "variations",
                                        value: e.target.value,
                                    },
                                });
                            }}
                        />
                    </Box>
                    <ButtonComponent text={buttonText} loading={loading} />
                </form>
            )}
        </Formik>
    );
};

export default VariationForm;
